import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { Overview } from './pages/Overview';
import { Charter } from './pages/Charter';
import { NCJI } from './pages/NCJI';
import { Contact } from './pages/Contact';
import { Constitution } from './pages/Constitution';
import { ConstitutionalPrinciples } from './pages/ConstitutionalPrinciples';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { About } from './pages/About';
import { Footer } from './components/Footer';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-cognarch-white text-cognarch-gray font-sans selection:bg-cognarch-black selection:text-white" data-id="element-2">
        <Navbar data-id="element-3" />
        <main data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/overview" element={<Overview data-id="element-9" />} data-id="element-8" />
            <Route path="/charter" element={<Charter data-id="element-11" />} data-id="element-10" />
            <Route path="/ncji" element={<NCJI data-id="element-13" />} data-id="element-12" />
            <Route path="/contact" element={<Contact data-id="element-15" />} data-id="element-14" />
            <Route path="/constitution" element={<Constitution data-id="element-17" />} data-id="element-16" />
            <Route path="/principles" element={<ConstitutionalPrinciples data-id="element-19" />} data-id="element-18" />
            <Route path="/privacy" element={<PrivacyPolicy data-id="element-21" />} data-id="element-20" />
            <Route path="/terms" element={<TermsOfService data-id="element-23" />} data-id="element-22" />
            <Route path="/about" element={<About data-id="element-25" />} data-id="element-24" />
          </Routes>
        </main>
        <Footer data-id="element-26" />
      </div>
    </BrowserRouter>;
}